export default __webpack_public_path__ + "static/media/instagram.741b7cc7.svg";